/** @file Emits event records (name and default int/float/string) in name order (R12-01). */
import { entriesByName } from '@pose2d/format/doc/entriesByName';
import type { Doc, Pose2DJson } from '@pose2d/format/types';

/** Events in name order (entriesByName, R12-01) and the id -> index map. */
export function compileEvents(doc: Doc): { events: Pose2DJson['events']; eventIndex: Map<string, number> } {
  const entries = entriesByName(doc.events);
  return {
    events: entries.map(([, e]) => ({ name: e.name, int: e.int, float: e.float, string: e.string })),
    eventIndex: new Map(entries.map(([id], i) => [id, i])),
  };
}
